export class DataManager {

    constructor(modelOrEndpoint) {

        if (!modelOrEndpoint)
            throw new Error('[DataManager]: "modelOrEndpoint" is required');

        this.model = (typeof modelOrEndpoint.getDataEndpoint === 'function')
            ? modelOrEndpoint
            : null;

        this.dataEndpoint = this.model
            ? this.model.getDataEndpoint()
            : modelOrEndpoint;

        if (!this.dataEndpoint)
            throw new Error('[DataManager]: data endpoint is required');

    };

    getModel() {

        return this.model;

    };

    getDataEndpoint() {

        return this.dataEndpoint;

    };

    queryData(query) {

        const model = this.getModel();
        return this.getDataEndpoint()
            .queryData(query)
            .then((result) => model?.deserializeDatasetFromWire ? model.deserializeDatasetFromWire(result) : result);

    };

    createData(data) {

        if (!data)
            throw new Error('Datamanager error: Can\'t create remote data. Data are empty.');

        const model = this.getModel();
        const serializedData = model?.serializeObjectForWire ? model.serializeObjectForWire(data) : data;

        return this.getDataEndpoint()
            .createData(serializedData)
            .then((result) => {
                if (!result || typeof result !== 'object' || Array.isArray(result))
                    return result;

                return model?.deserializeObjectFromWire ? model.deserializeObjectFromWire(result) : result;
            });

    };

    readData(data) {

        if (!data)
            throw new Error('Datamanager error: Can\'t read remote data. Data are empty.');

        const id = (data && data.id) || data || null;

        if (!id)
            throw new Error('Datamanager error: Can\'t read remote data. ID is missing.');

        const model = this.getModel();
        return this.getDataEndpoint()
            .readData(id)
            .then((result) => model?.deserializeObjectFromWire ? model.deserializeObjectFromWire(result) : result);

    };

    updateData(data) {

        if (!data)
            throw new Error('Datamanager error: Can\'t update remote data. Data are empty.');

        const id = (data && data.id) || null;

        if (!id)
            throw new Error('Datamanager error: Can\'t update remote data. ID is missing.');

        const model = this.getModel();
        const serializedData = model?.serializeObjectForWire ? model.serializeObjectForWire(data) : data;

        return this.getDataEndpoint().updateData(id, serializedData);

    };

    deleteData(data) {

        if (!data)
            throw new Error('Datamanager error: Can\'t delete remote data. Data are empty.');

        const id = (data && data.id) || data || null;

        if (!id)
            throw new Error('Datamanager error: Can\'t delete remote data. ID is missing.');

        return this.getDataEndpoint().deleteData(id);

    };

}
